<template>
  <div>
    <add-new-user
      :instituciones="listInstitutions"
      :user="user"
      :action="action"
      @recargar="recargar($event)"
      @recargarUpdate="recargarUpdate()"
    ></add-new-user>
    <b-modal
      id="modal-multi-3"
      size="sm"
      title="Confirmación"
      ok-title="Accept"
      v-model="showConfirmacionEliminar"
    >
      <b-card-text class="my-1">
        ¿Esta seguro de eliminar el usuario?
      </b-card-text>
      <template #modal-footer>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-primary"
          class="float-right mr-1"
          @click="showConfirmacionEliminar = false"
        >
          Cancelar
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right"
          @click="deleteUser(userSelected)"
        >
          Aceptar
        </b-button>
      </template>
    </b-modal>
    <b-tabs pills class="m-0">
      <b-tab title="Plataforma" :active="false" @click="getUsers(USER().rol)">
        <b-card no-body>
          <div
            v-if="
              USER().rol === ROLES.CLUB ||
                USER().rol === ROLES.TECNICA ||
                USER().rol === ROLES.SANCIONES ||
                USER().rol === ROLES.TESORERIA
            "
            class="misc-inner p-2 p-sm-3"
          >
            <div class="w-100 text-center">
              <h2 class="mb-1">
                Tú no estas autorizado! 🔐
              </h2>
              <p class="mb-2">
                No tienes los permisos para ver esta página. !!
              </p>
              <b-img
                fluid
                :src="require('@/assets/images/pages/not-authorized.svg')"
                alt="Pagina no autorizada"
                style="width:50%"
              />
            </div>
          </div>
          <template v-else>
            <div class="m-2">
              <b-row>
                <b-col
                  cols="12"
                  md="8"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <b-button
                    v-b-tooltip.hover.v-primary
                    title="Nuevo Usuario"
                    variant="flat-primary"
                    class="btn-icon"
                    @click="createUSer"
                  >
                    <feather-icon size="22" icon="UserPlusIcon" />
                  </b-button>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Buscar..."
                  />
                </b-col>
              </b-row>
            </div>
            <b-overlay :show="showLoading" rounded="sm">
              <div class="ml-1 mr-1">
                <b-table
                  ref="refInvoiceListTable"
                  :fields="tableColumns"
                  :items="listUsersFilter"
                  primary-key="id_usuario"
                  show-empty
                  responsive
                  small
                  :sticky-header="true"
                  :no-border-collapse="true"
                  empty-text="No se encontraron datos"
                  style="max-height:55vh"
                >
                  <template #cell(usuario)="data">
                    <div style="text-transform: capitalize">
                      {{ data.item.apellido }} {{ data.item.nombre }}
                    </div>
                  </template>
                  <!-- Column: Id -->
                  <template #cell(email)="data">
                    {{ data.item.email_user }}
                  </template>

                  <!-- Column: Actions -->
                  <template #cell(acciones)="data">
                    <div class="text-nowrap">
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-send-icon`"
                        icon="EditIcon"
                        class="cursor-pointer"
                        size="16"
                        @click="getDataUser(data.item)"
                      />
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="Trash2Icon"
                        size="16"
                        class="mx-1 cursor-pointer"
                        @click="showModalEliminar(data.item)"
                      />
                      <feather-icon
                        v-if="!showLoadingEmail"
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="SendIcon"
                        size="16"
                        class="cursor-pointer"
                        @click="reSendEmail(data.item)"
                      />
                      <b-spinner
                        style="visibility:hidden"
                        small
                        :id="`load${data.item.id_usuario}`"
                        label="Loading..."
                      />
                    </div>
                  </template>
                </b-table>
              </div>
            </b-overlay>
          </template>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  computed,
  onMounted,
  ref,
  watch,
  // xxx,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BCard,
  BCardText,
  //   VBTooltip,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BTab,
  BTabs,
  //   BMedia,
  //   BAvatar,
  VBTooltip,
  BOverlay,
  BImg,
  BSpinner,
  //   BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import {
  USER,
  ACTION_INSERT,
  ACTION_UPDATE,
  ROLES,
  //  xxx
} from '../../utils/variables'
import AddNewUser from './AddUser.vue'
import useUsers from './useUsers'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    AddNewUser,
    BTable,
    BCardText,
    BOverlay,
    BImg,
    BSpinner,
    BTab,
    BTabs,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const user = ref({})
    const action = ref('insert')
    const {
      getInstituciones,
      listInstitutions,
      listUsersFilter,
      listGremiosFilter,
      listUsers,
      // listGremios,
      userData,
      tableColumns,
      getUsers,
      getGremios,
      searchQuery,
      getEquiposEditar,
      showConfirmacionEliminar,
      showModalEliminar,
      deleteUser,
      userSelected,
      showLoading,
      reSendEmail,
      showLoadingEmail,
    } = useUsers()

    onMounted(() => {
      getUsers(USER().rol)
      getInstituciones(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      )
    })
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, data => {
      getUsers(USER().rol)
      getInstituciones(data.id_torneo)
    })
    function getPermisoEdicionPlayer(item) {
      let permissionPlayer = false
      if (item.editar_player === '1' || item.editar_player === true) {
        permissionPlayer = true
      }
      return permissionPlayer
    }
    function getPermisoAuditoria(item) {
      let permissionAuditor = false
      if (item.is_auditor === '1' || item.is_auditor === true) {
        permissionAuditor = true
      }
      return permissionAuditor
    }
    function getPermisoControlPlay(item) {
      console.log('item', item)
      let permissionControlPlay = false
      if (item.access_control_play === '1' || item.access_control_play === true) {
        permissionControlPlay = true
      }
      return permissionControlPlay
    }
    async function getDataUser(item) {
      item.institucionAuxiliar = {
        value: item.id_institucion,
        label: item.institucion,
      }
      item.listTeamsEdit = await getEquiposEditar(
        item.id_usuario,
        // eslint-disable-next-line
        item.id_institucion
      )
      // console.log(item)
      // user.value = item
      // user.value.email = item.email_user
      item.email = item.email_user
      item.permissionPlayer = getPermisoEdicionPlayer(item)
      item.permissionAuditoria = getPermisoAuditoria(item)
      item.permissionControlPlay = getPermisoControlPlay(item)
      user.value = { ...item }
      // console.log(item)
      action.value = ACTION_UPDATE
      store.commit('someVariables/UPDATE_SHOW_NEW_USER', true)
    }
    function createUSer() {
      store.commit('someVariables/UPDATE_SHOW_NEW_USER', true)
      //   store.commit('someVariables/UPDATE_ACTION_PLAYER', INSERT_DATA_PLAYER)
      user.value = { ...userData }
      action.value = ACTION_INSERT
      // console.log(user)
    }
    function insertUserPush(item) {
      // console.log(item)
      item.permissionPlayer = getPermisoEdicionPlayer(item)
      listUsers.value.push(item)
    }
    function recargar(item) {
      // getUsers(USER().rol)
      insertUserPush(item)
      // if (action.value === ACTION_UPDATE) {
      //   console.log('veces')
      //   this.$toast(
      //     {
      //       component: ToastificationContent,
      //       props: {
      //         title: 'USUARIO actualizado exitosamente',
      //         icon: 'AlertCircleIcon',
      //         variant: 'success',
      //         solid: true,
      //       },
      //     },
      //     {
      //       position: 'top-center',
      //       // eslint-disable-next-line
      //     }
      //   )
      // }
    }
    function recargarUpdate() {
      getUsers(USER().rol)
      if (action.value === ACTION_UPDATE) {
        // const found = listUsers.value.findIndex(
        //   // eslint-disable-next-line
        //   element => element.id_usuario === item.id_usuario
        // )
        // listUsers.value[found] = dataPrueba
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'USUARIO actualizado exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      }
    }

    return {
      createUSer,
      listInstitutions,
      userData,
      tableColumns,
      listUsersFilter,
      listGremiosFilter,
      listUsers,
      searchQuery,
      getDataUser,
      user,
      action,
      getUsers,
      USER,
      recargar,
      showConfirmacionEliminar,
      showModalEliminar,
      deleteUser,
      userSelected,
      showLoading,
      recargarUpdate,
      ROLES,
      reSendEmail,
      showLoadingEmail,
      getGremios,
    }
  },
}
</script>
